<template>
    <PlantConfigurationInductions :plantID="plantID"></PlantConfigurationInductions>
</template>

<script>
import PlantConfigurationInductions from '@/components/plants/configuration/PlantConfigurationInductions.vue';

export default {
    components: {
        PlantConfigurationInductions
    },
    data() {
        return {
            
        };
    },
    computed: {
        plantID() {
            return parseInt(this.$route.params.plantID);
        }
    },
    methods: {

    },
    created() {
        
    }
}
</script>

<style>

</style>
